import React from 'react'

export interface DelimiterData {
	style: 'star' | 'dash' | 'line'
	lineWidth: '8%' | '15%' | '25%' | '35%' | '50%' | '60%' | '100%'
	lineThickness: 1 | 2 | 3 | 4 | 5 | 6
}

export interface BEditorJsDelimiterProps {
	data: DelimiterData
}

export const BEditorJsDelimiter: React.FC<BEditorJsDelimiterProps> = ({ data }) => {
	const { style = 'line', lineWidth = '50%', lineThickness = 1 } = data

	const renderDelimeter = () => {
		switch (style) {
			case 'star':
				return (
					<div className='flex justify-center items-center'>
						<span className='text-[#4A337A] text-2xl'>★</span>
					</div>
				)
			case 'dash':
				return (
					<div className='flex justify-center items-center'>
						<div
							className='border-t border-dashed border-[#4A337A]'
							style={{
								width: lineWidth,
								borderTopWidth: lineThickness
							}}
						></div>
					</div>
				)
			case 'line':
			default:
				return (
					<div className='flex justify-center items-center'>
						<div
							className='border-t border-solid border-[#4A337A]'
							style={{
								width: lineWidth,
								borderTopWidth: lineThickness
							}}
						></div>
					</div>
				)
		}
	}

	return <div className='editorjs-renderer_block my-8'>{renderDelimeter()}</div>
}

export default BEditorJsDelimiter
